@if (!isProductionMode) {
  <app-helper-rights />
}

<div class="container">
  <header class="mobile-navigation-header">
    <button
      #mobileMenuButton
      tuiIconButton
      type="button"
      appearance="flat"
      class="mobile-menu-button"
      [iconStart]="isMobileMenuOpen ? '@tui.x' : '@tui.menu'"
      [attr.aria-label]="(isMobileMenuOpen ? 'Close' : 'Expand') | translate"
      [attr.aria-expanded]="isMobileMenuOpen"
      aria-controls="main-navigation"
      (click)="toggleMobileMenu()"
    ></button>

    @if (mobileHeader.template(); as headerTemplate) {
      <div
        class="mobile-navigation-header__slot"
        [class.mobile-navigation-header__slot_hidden]="isMobileMenuOpen"
        [attr.inert]="isMobileMenuOpen ? '' : null"
      >
        <ng-container [ngTemplateOutlet]="headerTemplate" />
      </div>
    }
  </header>

  <section class="content">
    <button
      type="button"
      class="mobile-navigation-backdrop"
      [class.mobile-navigation-backdrop_visible]="isMobileMenuOpen"
      [attr.tabindex]="isMobileMenuOpen ? 0 : -1"
      [attr.aria-hidden]="!isMobileMenuOpen"
      [attr.aria-label]="'Close' | translate"
      (click)="closeMobileMenu()"
    ></button>

    <app-sidebar
      id="main-navigation"
      [mobileOpen]="isMobileMenuOpen"
      (changeSidebarState)="changeSidebarState($event)"
      (navigationSelected)="closeMobileMenu()"
    />

    <div class="main-content" [class]="expandState ? 'with-expand' : 'without-expand'">
      <router-outlet />
    </div>
  </section>

  <app-push-blocked-account />
</div>
